import { render, staticRenderFns } from "./AuthedDeleteReq.vue?vue&type=template&id=58070c62&scoped=true"
import script from "./AuthedDeleteReq.vue?vue&type=script&lang=js"
export * from "./AuthedDeleteReq.vue?vue&type=script&lang=js"
import style0 from "./AuthedDeleteReq.vue?vue&type=style&index=0&id=58070c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58070c62",
  null
  
)

export default component.exports